import { Component, OnInit } from '@angular/core';
import { LoadingService } from '../shared/loading/loading.service';
import { Router } from '@angular/router';

@Component({
  selector: 'my-privacy-short',
  template: require('./privacy-short.component.html'),
  styles: [require('./privacy-short.component.scss'), require('../shared/styles/form.scss')]
})
export class PrivacyShortComponent implements OnInit {

  constructor(
    private loadingService: LoadingService,
    private router: Router) {
    // Do stuff
  }

  ngOnInit() {
    console.log('privacy short');
    this.loadingService.hideLoading();
  }
  gotoLogin() {
    this.router.navigate(['/login']);
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/privacy-short/privacy-short.component.ts